import * as Sentry from '@sentry/browser';
import { TCountryCode } from 'interfaces';
import { pick } from 'lodash-es';
import { useState } from 'react';
import { BookingBuilderRequest, IPriceCheckReq, IPriceCheckResAccommodation, ITravelAgent, makeBackendApi } from 'services/BackendApi';
import { iActingOnBehalfOfUser } from 'store/modules/actingOnBehalfOf/model';

type UsePriceCheckAPI = {
  bookingBuilderRequest: BookingBuilderRequest;
  selectedTa?: ITravelAgent | null,
  actingOnBehalfOfUser?: iActingOnBehalfOfUser | null;
  clientCountryCode?: TCountryCode | null;
};

export const usePriceCheckAPI = (props: UsePriceCheckAPI) => {
  const [data, setData] = useState<IPriceCheckResAccommodation[] | null>(null)
  const [isLoading, setLoading] = useState<boolean>(false);

  const request = async (): Promise<IPriceCheckResAccommodation[] | null> => {
    const payload: IPriceCheckReq = {
      Accommodation: props.bookingBuilderRequest.Accommodation.map(x => ({
        ...pick(x, 'uuid', 'startDate', 'endDate', 'guestAges'),
        liveRate: pick(x.liveRate!, 'externalRateId', 'externalMealPlanCode'),
      }))
    };

    const backendApi = makeBackendApi(props.selectedTa?.uuid);
    setLoading(true);

    try {
      const res = await backendApi.liveRatesPriceCheck(
        props.bookingBuilderRequest.hotelUuid,
        payload,
        props.clientCountryCode,
        props.actingOnBehalfOfUser
      );
      setData(res.data.data.Accommodation);
      return res.data.data.Accommodation;
    } catch (e) {
      console.error('Price check failed:', e);
      Sentry.captureException(e);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    request,
    isLoading,
    data
  };
};
